import * as React from "react"
import type { SVGProps } from "react"
const SvgTwoPeople = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M1 17.34q0-.84.44-1.56.44-.71 1.16-1.09a15 15 0 0 1 3.15-1.16A14 14 0 0 1 9 13.14a14 14 0 0 1 6.4 1.55q.72.38 1.16 1.09.45.72.44 1.56v.8q0 .82-.59 1.42a2 2 0 0 1-1.41.58H3q-.83 0-1.41-.58A2 2 0 0 1 1 18.13zm20 2.8h-2.55a3.7 3.7 0 0 0 .55-2v-1q0-1.1-.61-2.11a5.4 5.4 0 0 0-1.74-1.74 13 13 0 0 1 4.5 1.4q.9.5 1.38 1.12.47.6.47 1.33v1q0 .82-.59 1.42a2 2 0 0 1-1.41.58m-12-8q-1.65 0-2.82-1.17Q5 9.79 5 8.14c0-1.65.4-2.04 1.17-2.82Q7.36 4.14 9 4.14c1.65 0 2.04.4 2.83 1.18Q13 6.49 13 8.14c0 1.65-.4 2.04-1.17 2.83A4 4 0 0 1 9 12.14m10-4q0 1.65-1.17 2.83a3.9 3.9 0 0 1-3.53 1.11 6 6 0 0 1-.7-.14 6 6 0 0 0 1.04-1.77 5.8 5.8 0 0 0 0-4.05 6 6 0 0 0-1.04-1.78 3 3 0 0 1 .7-.16q.35-.04.7-.04 1.65 0 2.82 1.18A4 4 0 0 1 19 8.14m-16 10h12v-.8a1 1 0 0 0-.5-.85q-1.35-.67-2.72-1.01a11.6 11.6 0 0 0-5.55 0q-1.38.33-2.73 1.01a1 1 0 0 0-.5.85zm6-8q.82 0 1.41-.58.6-.6.59-1.42 0-.82-.59-1.41A2 2 0 0 0 9 6.14q-.82 0-1.41.59A2 2 0 0 0 7 8.14q0 .82.59 1.42.59.58 1.41.58" />
  </svg>
)
export default SvgTwoPeople
